module.exports = __webpack_public_path__ + "img/search-duotone.d292ba12.svg";